import setHiddenSlides from '../../../../src/js/set-hidden-slides';

class InteractiveTeam {
	constructor() {
		this.block = document.querySelector('.block-interactive-team');
		if (null !== this.block) {
			this.image = this.block.querySelector('.featured-team-img-wrapper');
			this.scrollSection = document.querySelector('.block-interactive-team__scroll-section');

			const setImageSize = this.setImageSize.bind(this);

			this.scrollSection.addEventListener('in-view:in', () => {
				document.addEventListener('scroll', setImageSize, { passive: true });
			});

			this.scrollSection.addEventListener('in-view:out', () => {
				document.removeEventListener('scroll', setImageSize);
			});

			this.initSlider();
		}
	}

	setImageSize() {
		const scrollTop = window.scrollY - this.scrollSection.offsetTop;
		const maxScrollTop = this.scrollSection.offsetHeight - this.image.offsetHeight;
		let ratio = scrollTop / maxScrollTop;

		if (ratio < 0) {
			ratio = 0;
		} else if (ratio > 1) {
			ratio = 1;
		}

		const scale = 1 - ratio * 0.1;
		this.image.style.transform = `scale(${scale})`;
	}

	initSlider() {
		// eslint-disable-next-line no-undef
		new Swiper('.team-slider__wrapper', {
			a11y: {
				slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
			},
			on: {
				init: setHiddenSlides,
				slideChangeTransitionEnd: setHiddenSlides,
				breakpoint: setHiddenSlides,
			},
			slidesPerView: 1,
			spaceBetween: 40,
			loop: true,
			breakpoints: {
				700: {
					slidesPerView: 2,
				},
			},
			navigation: {
				nextEl: '.team-slider__next',
				prevEl: '.team-slider__prev',
			},
		});
	}
}

new InteractiveTeam();
